<template>
  <div>
    <div class="wrapper">
      <input type="file" @change="setSimpleImage" />
      <a class="button cta success" @click="uploadSimple">UPLOAD</a>
    </div>
    <div class="wrapper">
      <div id="app">
        <h2 style="margin: 0;">Vue CropperJS</h2>
        <hr />
        <input type="file" name="image" accept="image/*"
          style="font-size: 1.2em; padding: 10px 0;"
          @change="setImage"
        />
        <br />
        <div style="max-width: 900px; display: inline-block;">
          <vue-cropper
            ref='cropper'
            :guides="false"
            :cropBoxResizable="false"
            drag-mode="crop"
            :zoom="cropImage"
            :view-mode="2"
            :checkOrientation="false"
            :min-container-width="500"
            :min-container-height="500"
            :background="true"
            :src="imgSrc"
            alt="Source Image"
            :img-style="{ width: '500px', 'height': '500px' }"
            :cropmove="cropImage"
          ></vue-cropper>
        </div>
        <img :src="cropImg"
          style="max-width: 500px; max-height: 500px; border: 1px solid gray"
          alt="Cropped Image"
        />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'

export default {
  name: 'test',
  data () {
    return {
      imgSrc: '',
      cropImg: '',
      mediaHost: 'https://staging-media.opoli.com/api/upload',
      // mediaHost: 'http://localhost/upload/',
      simpleFile: new FormData()
    }
  },
  components: {
	},
  methods: {
    setImage (e) {
      let self = this
      const file = e.target.files[0];

      if (!file.type.includes('image/')) {
        alert('Please select an image file');
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          setTimeout(function () {
            self.cropImage()
          }, 50)
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage () {
      let self = this
      // get image data for post processing, e.g. upload or setting image src
      self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

      self.$refs.cropper.getCroppedCanvas({width: 500, height: 500}).toBlob(function (blob) {
        console.log(blob)
        // let fd = new FormData()
        // fd.append('pic', blob, 'test.jpg')
        // self.$http.post(self.mediaHost, fd, {
        //   header: {
        //     'Content-Type': 'multipart/form-data'
        //   }
        // }).then(function (res) {
        //   console.log('success', res)
        // }, function (res) {
        //   console.log('error', res)
        // });
      }, 'image/jpeg', 0.8)
    },
    setSimpleImage (e) {
      let self = this
      let file = e.target.files[0];
      console.log('#FILE2', file)
      this.simpleFile.append('pic', file)

      self.$http.post(self.mediaHost + '/api/upload', self.simpleFile, {
        header: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        console.log('success', res)
        console.log('URL', res.body.data.url)
      }, function (res) {
        console.log('error', res)
      });
    },
    uploadSimple () {
      let self = this
      self.$http.post(self.mediaHost + '/api/upload', self.simpleFile, {
        header: {
          'Content-Type': 'multipart/form-data',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (res) {
        console.log('success', res)
      }, function (res) {
        console.log('error', res)
      });
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.wrapper{
  width: 600px;
  margin: 0 auto;
  background: #fafafa;
  padding: 20px;
  box-shadow: 0 0 5px rgba(0,0,0, .5);
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/TestUpload/index.vue